export const PERMS = {
    READ: 'company_numberings.read',
    UPDATE: 'company_numberings.update',
    DELETE: 'company_numberings.delete',
    CREATE: 'company_numberings.create',
}
